import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_PM_SAFETY_AUDIT_SUMMARY_API } from "./apiRoutes";

interface Props {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getSafetyAuditSummary = async (projectId: string) => {
  return await axiosAuth.get(`${DASHBOARD_PM_SAFETY_AUDIT_SUMMARY_API(projectId)}`);
};

const useGetPmSafetyAuditSummary = ({ projectId, queryParams }: Props): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-safety-audit-summary", projectId],
    queryFn: () => getSafetyAuditSummary(projectId),
    select: (data: any) => data.data.data,
    refetchOnWindowFocus: false,
    enabled: !!projectId,
    ...queryParams,
  });
};

export default useGetPmSafetyAuditSummary;
